import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 21l12 -7v-7.5l-6 -3.5l-6 3.5l6 3.5v7.5l-6 -3.5l0 7","key":"svg-0"}]]

const IconBrandPrintables = createReactComponent('outline', 'brand-printables', 'BrandPrintables', __iconNode);

export default IconBrandPrintables;